import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from 'react-bootstrap';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import OverlayLoader from '../../../components/overlayLoader';
import FormInput from '../../../components/forms/formInput';
import { createEmployee, getEmployeeById, updateEmployee } from '../../../services/employees';
import { trimProps } from '../../../utils/helper';
import { onMutateSuccess, onQuerySuccess } from '../../../utils/queryResponse';
import SbrDrawer from '../../../components/sbr/SbrDrawer';

const UserIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
);

const initEmployee = {
    firstName: '',
    lastName: ''
}

const SetEmployeeModal = ({
    display,
    toggle,
    employeeId,
}) => {

    const { t } = useTranslation();
    const [employee, setEmployee] = useState(initEmployee)

    const onShow = () => {
        !employeeId && setEmployee(initEmployee)
    }

    const onHide = () => {
        toggle(false)
    }

    const queryClient = useQueryClient()

    const { mutate, isLoading } = useMutation( employeeId ? updateEmployee : createEmployee, {
        onSuccess: onMutateSuccess(() => {
            queryClient.invalidateQueries(['employees'])
            onHide()
        })
    })

    const { data, isFetching } = useQuery(['employees','details', employeeId], () => employeeId && getEmployeeById(employeeId))

    useEffect(() => {
        onQuerySuccess(data, (result) => {
            const _employee = trimProps(result, initEmployee, ['id'])
            setEmployee(_employee)
        })
    }, [data])

    const handleSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()

        mutate(employee)
    }

    const handleChange = (objValue) => {
        const newEmployee = { ...employee, ...objValue }
        setEmployee(newEmployee)
    }

    return (
        <SbrDrawer
            show={display}
            onHide={onHide}
            onShow={onShow}
            secondary
            backdrop={isLoading ? 'static' : true}
            title={employeeId ? t('settingsPage.editEmployeeTitle') : t('settingsPage.addEmployeeTitle')}
            subtitle={employeeId ? t('settingsPage.editEmployeeSubtitle') : t('settingsPage.addEmployeeSubtitle')}
            icon={<UserIcon />}
            footer={
                <>
                    <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={onHide} disabled={isLoading}>{t('common.cancel')}</button>
                    <button type='submit' form="set-employee" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isLoading}>
                        {isLoading ? t('settingsPage.submitting') : (employeeId ? t('settingsPage.saveEmployee') : t('settingsPage.addEmployeeBtn'))}
                    </button>
                </>
            }
        >
            <Form id='set-employee' onSubmit={handleSubmit} style={{ position: 'relative' }}>
                <Row className="mb-3">
                    <Col lg="6">
                        <FormInput className="form-control mb-2" label={t('settingsPage.firstName')} value={employee.firstName ?? ''}
                            onChange={(e) => handleChange({ firstName: e.target.value })} required
                        />
                    </Col>
                    <Col lg="6">
                        <FormInput className="form-control mb-2" label={t('settingsPage.lastName')} value={employee.lastName ?? ''}
                            onChange={(e) => handleChange({ lastName: e.target.value })} required
                        />
                    </Col>
                </Row>

                {isFetching &&
                    <OverlayLoader />
                }
            </Form>
        </SbrDrawer>
    )
}

export default SetEmployeeModal
